var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { computed } from "mobx";
import { RacingEventTypes, RacingStore, RacingStateIds } from "../../../data";
import { NextRacesEvent } from "./NextRaces";
import { HRLineState } from "sb-legacy-integration";
var RacingNextRacesData = /** @class */ (function () {
    function RacingNextRacesData(provider, utils, cmsOptionsComposition, openRaceEvent) {
        this.provider = provider;
        this.racingStore = RacingStore.getInstance;
        this.racingStore.webMethods = {
            pageMethods: provider.pageMethods,
            racingPageMethods: provider.racingPageMethods
        };
        this.racingStore.nextRacesCount = cmsOptionsComposition.nextRacesCount;
        this.racingGameNavigation = openRaceEvent;
        this.betSlipUtil = utils.betSlipUtil;
        this.oddsUtil = utils.oddsUtil;
        this.racingStore.setFacade(utils.facade);
        this.nextRacesCount = cmsOptionsComposition.nextRacesCount;
        this.nextLinesCount = cmsOptionsComposition.nextLinesCount;
        this.nextRacesRowsHeight = this.nextLinesCount * cmsOptionsComposition.nextRacesRowHeight;
    }
    // TODO: Remove when new event view is available
    /* istanbul ignore next */
    RacingNextRacesData.prototype.openRacingGame = function (racecardId, regionId, mode, branchId, trapMarketId, bettingWithoutFavId, bettingWithoutTwoFavId, placeOnlyId, matchBettingId, toteId, totePlaceOnlyId, auPlaceOnlyId, event) {
        /* istanbul ignore next */
        this.racingGameNavigation(event, racecardId, regionId, mode, branchId, trapMarketId, bettingWithoutFavId, bettingWithoutTwoFavId, placeOnlyId, matchBettingId, toteId, totePlaceOnlyId, auPlaceOnlyId);
    };
    RacingNextRacesData.prototype.isLineInBetSlip = function (lineid, eventId) {
        return this.betSlipUtil.isOddInSlip(0, eventId, lineid, 0, 0, 7, false, true);
    };
    RacingNextRacesData.prototype.getRacingMode = function (eventId) {
        if (this.racingStore.todaysEvents.find(function (x) { return x.id === eventId; })) {
            return 0;
        }
        else if (this.racingStore.tomorrowEvents.find(function (x) { return x.id === eventId; })) {
            return 1;
        }
        return 2;
    };
    Object.defineProperty(RacingNextRacesData.prototype, "getNextRaces", {
        get: function () {
            var nextRaces = this.racingStore.todaysEvents.concat(this.racingStore.tomorrowEvents);
            nextRaces = this.racingStore.sortEventByDate(nextRaces);
            var nextRacesAr = [];
            var evCount = 0;
            this.racingStore.oddstyleChaged; //Hack to redraw on oddstyle change.
            for (var i = 0; i < nextRaces.length; i += 1) {
                var masterEvent = nextRaces[i];
                /* istanbul ignore next */
                if (evCount === this.nextRacesCount) {
                    break;
                }
                /* istanbul ignore next */
                if (masterEvent.raceProgress !== 0) {
                    continue;
                }
                var _loop_1 = function (index) {
                    var ev = masterEvent.racingEvents[index];
                    /* istanbul ignore next */
                    if (parseInt(ev.typeId) !== RacingEventTypes.RaceCard) {
                        return "continue";
                    }
                    var lines = [];
                    var count = 0;
                    var sortedLines = ev.sortedLinesByOdds;
                    var _loop_2 = function (index_1) {
                        /* istanbul ignore next */
                        var line = sortedLines[index_1];
                        /* istanbul ignore next */
                        if (count === this_1.nextLinesCount) {
                            return "break";
                        }
                        /* istanbul ignore next */
                        var rcLine = ev.racecardLines.find(function (x) { return x.lineId === line.id; });
                        /* istanbul ignore next */
                        var showSP = ev.racingStateId === RacingStateIds.SP || (this_1.isLineSP(line.lineTypeId) && line.odds === 0);
                        var isWithdrawn = line.lineStateId === HRLineState.Withdrawn;
                        /* istanbul ignore next */
                        lines.push({
                            id: line.id,
                            eventId: ev.id,
                            src: rcLine ? rcLine.silkData : undefined,
                            isSP: showSP,
                            isNR: isWithdrawn,
                            odds: this_1.oddsUtil.convertFormat(line.odds, parseInt(ev.typeId), parseInt(line.lineTypeId), undefined, undefined, undefined, parseInt(ev.branchId), line.fractOddsDividend + "/" + line.fractOddsDivisor),
                            fixture: {
                                top: line.lineName,
                                bottom: this_1.racingStore.branchId === 61 && rcLine ? rcLine.trainer + " / " + rcLine.jockey : ""
                            },
                            handler: this_1.betSlipUtil.addQAOddHR.bind(this_1, 0, Number(ev.id), Number(line.id), line.odds, this_1.racingStore.regionId, ev.raceProgress, Number(ev.typeId))
                        });
                        count += 1;
                    };
                    for (var index_1 = 0; index_1 < sortedLines.length; index_1++) {
                        var state_1 = _loop_2(index_1);
                        if (state_1 === "break")
                            break;
                    }
                    var league = this_1.racingStore.leagues.find((function (x) { return x.masterLeagueId === ev.masterLeagueId; }));
                    /* istanbul ignore next */
                    var currentLeagueName = league ? league.name : "";
                    var currentLeagueId = league ? league.id : "-1";
                    evCount += 1;
                    nextRacesAr.push(new NextRacesEvent({
                        id: ev.id,
                        date: ev.date,
                        hasLiveStream: ev.hasLiveStream,
                        leagueName: currentLeagueName,
                        rows: lines,
                        url: this_1.racingStore.getRacingEventUrl(ev.urlCode, currentLeagueId),
                        handler: this_1.openRacingGame.bind(this_1, this_1.racingStore.getMasterEventSpecificEventType(masterEvent, RacingEventTypes.RaceCard), this_1.racingStore.regionId, 
                        /* istanbul ignore next */
                        this_1.getRacingMode(masterEvent.id), Number(this_1.racingStore.branch.id), this_1.racingStore.getMasterEventSpecificEventType(masterEvent, RacingEventTypes.TrapMarket), this_1.racingStore.getMasterEventSpecificEventType(masterEvent, RacingEventTypes.BettingWithoutFav), this_1.racingStore.getMasterEventSpecificEventType(masterEvent, RacingEventTypes.BettingWithoutTwoFav), this_1.racingStore.getMasterEventSpecificEventType(masterEvent, RacingEventTypes.PlaceOnly), this_1.racingStore.getMasterEventSpecificEventType(masterEvent, RacingEventTypes.MatchBetting), this_1.racingStore.getMasterEventSpecificEventType(masterEvent, RacingEventTypes.AUHRTote), this_1.racingStore.getMasterEventSpecificEventType(masterEvent, RacingEventTypes.AUHRTotePlaceOnly), this_1.racingStore.getMasterEventSpecificEventType(masterEvent, RacingEventTypes.AUHRPlaceOnly))
                    }));
                };
                var this_1 = this;
                for (var index = 0; index < masterEvent.racingEvents.length; index++) {
                    _loop_1(index);
                }
            }
            return nextRacesAr;
        },
        enumerable: true,
        configurable: true
    });
    // TODO: Create Util for lines validations
    /* istanbul ignore next */
    RacingNextRacesData.prototype.isLineSP = function (lineTypeId) {
        switch (parseInt(lineTypeId)) {
            case 24:
            case 25:
            case 26:
            case 27:
            case 28:
            case 29:
                /* istanbul ignore next */
                return true;
            default:
                /* istanbul ignore next */
                return false;
        }
    };
    Object.defineProperty(RacingNextRacesData.prototype, "isDataLoaded", {
        get: function () {
            return !this.racingStore.isDataLoading;
        },
        enumerable: true,
        configurable: true
    });
    // private resolve(res) {
    // }
    // private reject(res) {
    // }
    RacingNextRacesData.prototype.setParams = function (regionId, branchId) {
        this.racingStore.setParams(regionId, branchId);
    };
    __decorate([
        computed,
        __metadata("design:type", Array),
        __metadata("design:paramtypes", [])
    ], RacingNextRacesData.prototype, "getNextRaces", null);
    __decorate([
        computed,
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], RacingNextRacesData.prototype, "isDataLoaded", null);
    return RacingNextRacesData;
}());
export { RacingNextRacesData };
//# sourceMappingURL=RacingNextRacesData.js.map